import React, { useState, useEffect, useRef, useCallback } from "react";
import { ModulosEnum } from "../../../shared/enum/modulos.enum";
import { PermissoesEnum } from "../../../shared/enum/permicao.enum";
import { useAuth } from "../../../AuthContext/AuthContext";
import { GetContribuinteDto } from "../../../shared/dtos/Contribuinte.dto";
import contribuinteService from "../../../services/ContribuinteService";
import Button from "../../../components/Button/button";
import {
  ContainerButtons,
  ContainerFilter,
  LoadingContainer,
  MainContainer,
} from "./styles";
import {
  GrayTitle,
  LoadingGif,
  StyledHR,
} from "../../../shared/styles/global.styles";
import loadSCGif from "../../../assets/load_SC.gif";
import { Label } from "../../../components/Label/styles";
import InputComponent from "../../../components/Input/input";
import { IoSearchSharp } from "react-icons/io5";
import { IoIosArrowBack, IoIosDocument } from "react-icons/io";
import { MdOutlineViewColumn } from "react-icons/md";
import { Dropdown } from "react-bootstrap";
import {
  DropdownDivider,
  DropdownScroll,
} from "../../../components/Dropdowns/styles";
import { Colors } from "../../../shared/colors/colors";
import {
  MenuTableDivider,
  Table,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  TableContainer,
} from "../../../components/Table/styles";
import Pagination from "../../../components/Pagination/pagination";
import DeclaracaoModal from "./DeclaracaoModal/DeclaracaoModal";

const DeclaracaoAnualContribuicaoVoluntaria: React.FC = () => {
  const { checkPermission } = useAuth();
  const editOnly = checkPermission(
    ModulosEnum.CONTRIBUINTE,
    PermissoesEnum.ESCRITA
  );

  const detailsOnly = !!(
    checkPermission(ModulosEnum.DADOS_PESSOAIS, PermissoesEnum.LEITURA) ||
    checkPermission(ModulosEnum.MOVIMENTACOES, PermissoesEnum.LEITURA) ||
    checkPermission(ModulosEnum.DEPENDENTES, PermissoesEnum.LEITURA) ||
    checkPermission(ModulosEnum.DADOS_FINANCEIROS, PermissoesEnum.LEITURA) ||
    checkPermission(ModulosEnum.FICHA_FINANCEIRA, PermissoesEnum.LEITURA)
  );

  const [filteredContribuintes, setFilteredContribuintes] = useState<
    GetContribuinteDto[]
  >([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [totalContribuintes, setTotalContribuintes] = useState(0);
  const [isSearchEmpty, setIsSearchEmpty] = useState(true);
  const defaultColumns = [
    "CPF",
    "Nome",
    "Data de Nascimento",
    "Cidade",
    "Celular",
  ];
  // Função para garantir que sempre tenhamos pelo menos as colunas padrão
  const ensureDefaultColumns = (columns: string[]) => {
    return columns.length > 0 ? columns : defaultColumns;
  };
  const loadVisibleColumns = () => {
    try {
      const savedColumns = sessionStorage.getItem("contribuintesVisibleColumns");
      if (!savedColumns) return defaultColumns;

      const parsedColumns = JSON.parse(savedColumns);
      return ensureDefaultColumns(parsedColumns);
    } catch (error) {
      console.error("Erro ao carregar colunas:", error);
      return defaultColumns;
    }
  };
  const [contribuintesVisibleColumns, setVisibleColumns] = useState<string[]>(
    loadVisibleColumns()
  );
  const [tempVisibleColumns, setTempVisibleColumns] = useState<string[]>(
    loadVisibleColumns()
  );
  const totalPages = Math.ceil(totalContribuintes / itemsPerPage);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [showColumnSelector, setShowColumnSelector] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [selectedContribuinte, setSelectedContribuinte] =
    useState<GetContribuinteDto | null>(null);
  const cpfInputRef = useRef<HTMLInputElement>(null);
  const columnSelectorRef = useRef<HTMLDivElement>(null);
  const [isOpenMenuCollumn, setIsOpenMenuCollumn] = useState(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  // Atualiza os dados completos ao apagar a pesquisa
  const fetchContribuintes = useCallback(
    async (page: number, searchTerm: string) => {
      try {
        const response = await contribuinteService.getAllContribuintes(
          page,
          itemsPerPage,
          searchTerm
        );
        // setContribuintes(response.data);
        setFilteredContribuintes(response.data);
        setTotalContribuintes(response.total);
        setLoading(true);
      } catch (error) {
        console.error("Erro ao buscar contribuintes:", error);
        setError("Não foi possível carregar os contribuintes.");
      } finally {
        setLoading(false);
      }
    },
    []
  );

  const handleSearchChange = (value: string) => {
    setCurrentPage(1); // volta para a primeira página
    setSearch(value); // atualiza o estado de busca
  };

  const formatCpf = (cpf: string | number): string => {
    return cpf
      .toString()
      .padStart(11, "0")
      .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  const handleColumnToggle = (column: string) => {
    // Se a coluna é padrão, não permite desmarcar
    if (defaultColumns.includes(column)) {
      return;
    }

    setTempVisibleColumns((prev: string[]) => {
      return prev.includes(column)
        ? prev.filter((col) => col !== column)
        : [...prev, column];
    });
  };

  const handleApplyColumns = () => {
    const columnsToSave = ensureDefaultColumns(tempVisibleColumns);
    setVisibleColumns(columnsToSave);
    sessionStorage.setItem(
      "contribuintesVisibleColumns",
      JSON.stringify(columnsToSave)
    );
    setIsOpenMenuCollumn(false);
  };

  const selectContribuinte = (data: GetContribuinteDto) => {
    setSelectedContribuinte(data);
    setShowModal(true);
  };

  const handlePageChange = (pageNumber: number) => {
    setLoading(true);
    setCurrentPage(pageNumber);
    fetchContribuintes(pageNumber, search); // Atualiza os dados para a página selecionada
  };

  // useEffect(() => {
  //   const handleClickOutside = (event: MouseEvent) => {
  //     if (
  //       columnSelectorRef.current &&
  //       !columnSelectorRef.current.contains(event.target as Node)
  //     ) {
  //       setShowColumnSelector(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);

  // useEffect(() => {
  //   fetchContribuintes(currentPage, search);
  // }, []);

  useEffect(() => {
    if (search !== "") {
      setCurrentPage(1);
      fetchContribuintes(1, search);
    }
  }, [search]);

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(Math.max(totalPages, 1)); // Garante que a página seja válida
    }
  }, [totalPages]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownMenuRef.current &&
        !dropdownMenuRef.current.contains(event.target as Node)
      ) {
        setIsOpenMenuCollumn(false); // Fecha o dropdown
      }
    };

    // Adiciona o event listener quando o menu estiver aberto
    if (isOpenMenuCollumn) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    // Limpeza do event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenMenuCollumn]);

  useEffect(() => {
    if (isOpenMenuCollumn) {
      setTempVisibleColumns(contribuintesVisibleColumns); // Inicializa o estado temporário com as colunas visíveis atuais
    }
  }, [isOpenMenuCollumn, contribuintesVisibleColumns]);

  return (
    <>
      <MainContainer>
        <GrayTitle>Declaração de recebimento de doações voluntária</GrayTitle>
        <StyledHR />
        <>
          <Label htmlFor="cpf-search" id="form-label">
            Pesquisar por Nome ou CPF:
          </Label>
          <ContainerFilter>
            <InputComponent
              type="text"
              id="cpf-search"
              ref={cpfInputRef}
              value={search}
              onChange={(e) => handleSearchChange(e.target.value)}
              placeholder="Busque por Nome ou CPF do contribuinte"
              autoFocus
              maxLength={45}
              color="black"
              width={399}
              iconLeft={
                isSearchEmpty ? (
                  <IoSearchSharp size={24} color={Colors.inputIcon} />
                ) : (
                  <IoIosArrowBack size={24} color={Colors.inputIcon} />
                )
              }
              onIconLeftClick={() => {
                if (!isSearchEmpty) {
                  setSearch("");
                  setIsSearchEmpty(true);
                  setCurrentPage(1);
                  fetchContribuintes(1, "");
                }
              }}
              className="no-outline"
            />

            {filteredContribuintes.length > 0 && (
              <ContainerButtons>
                <Button
                  schemaButton="out-primary"
                  action={() => setIsOpenMenuCollumn(!isOpenMenuCollumn)}
                  icon={
                    <MdOutlineViewColumn
                      size={20}
                      style={{ marginRight: "8px" }}
                    />
                  }
                >
                  Colunas
                </Button>

                <Dropdown.Menu
                  ref={dropdownMenuRef}
                  show={isOpenMenuCollumn}
                  style={{ marginTop: "50px" }}
                >
                  <DropdownScroll>
                    {[
                      "Nome",
                      "CPF",
                      "Email",
                      "Sexo",
                      "RG",
                      "Data de Nascimento",
                      "CEP",
                      "Endereço",
                      "Complemento",
                      "Bairro",
                      "Cidade",
                      "Telefone Residencial",
                      "Telefone Comercial",
                      "Telefone Recado",
                      "Celular",
                    ].map((column, index, array) => (
                      <React.Fragment key={column}>
                        {!defaultColumns.includes(column) && (
                          <Dropdown.Item
                            eventKey="1"
                            onClick={() => handleColumnToggle(column)}
                            style={{ color: Colors.primary }}
                          >
                            <img
                              src={
                                tempVisibleColumns.includes(column)
                                  ? "/images/checkbox-marked.svg"
                                  : "/images/checkbox-blank-outline.svg"
                              }
                              alt={
                                tempVisibleColumns.includes(column)
                                  ? defaultColumns.includes(column)
                                    ? "Bloqueado"
                                    : "Selecionado"
                                  : "Não selecionado"
                              }
                              className="checkbox-image"
                            />
                            <label>{column}</label>
                            {array
                              .filter((col) => !defaultColumns.includes(col))
                              .indexOf(column) <
                              array.filter(
                                (col) => !defaultColumns.includes(col)
                              ).length -
                                1 && <DropdownDivider />}
                          </Dropdown.Item>
                        )}
                      </React.Fragment>
                    ))}
                  </DropdownScroll>
                  {JSON.stringify(tempVisibleColumns.sort()) !==
                    JSON.stringify(contribuintesVisibleColumns.sort()) && (
                    <Dropdown.Item>
                      <MenuTableDivider />
                      <Button
                        schemaButton="with-margin"
                        action={handleApplyColumns}
                      >
                        Aplicar
                      </Button>
                    </Dropdown.Item>
                  )}
                </Dropdown.Menu>
              </ContainerButtons>
            )}
          </ContainerFilter>
          <StyledHR />
          {error ? (
            <div id="erro-mensagem" className="alert alert-danger" role="alert">
              {error}
            </div>
          ) : (
            <TableContainer>
              <div className="table-wrapper">
                {loading ? (
                  <LoadingContainer>
                    <LoadingGif src={loadSCGif} alt="Carregando..." />
                  </LoadingContainer>
                ) : (
                  <Table id="contribuintes-tabela">
                    <TableHead>
                      <TableRow>
                        {contribuintesVisibleColumns.includes("Nome") && (
                          <TableHeader>Nome</TableHeader>
                        )}
                        {contribuintesVisibleColumns.includes("CPF") && (
                          <TableHeader>CPF</TableHeader>
                        )}
                        {contribuintesVisibleColumns.includes("Email") && (
                          <TableHeader>Email</TableHeader>
                        )}
                        {contribuintesVisibleColumns.includes("Sexo") && (
                          <TableHeader>Sexo</TableHeader>
                        )}
                        {contribuintesVisibleColumns.includes("RG") && (
                          <TableHeader>RG</TableHeader>
                        )}
                        {contribuintesVisibleColumns.includes(
                          "Data de Nascimento"
                        ) && <TableHeader>Data de Nascimento</TableHeader>}
                        {contribuintesVisibleColumns.includes("CEP") && (
                          <TableHeader>CEP</TableHeader>
                        )}
                        {contribuintesVisibleColumns.includes("Endereço") && (
                          <TableHeader>Endereço</TableHeader>
                        )}
                        {contribuintesVisibleColumns.includes(
                          "Complemento"
                        ) && <TableHeader>Complemento</TableHeader>}
                        {contribuintesVisibleColumns.includes("Bairro") && (
                          <TableHeader>Bairro</TableHeader>
                        )}
                        {contribuintesVisibleColumns.includes("Cidade") && (
                          <TableHeader>Cidade</TableHeader>
                        )}
                        {contribuintesVisibleColumns.includes(
                          "Telefone Residencial"
                        ) && <TableHeader>Telefone Residencial</TableHeader>}
                        {contribuintesVisibleColumns.includes(
                          "Telefone Comercial"
                        ) && <TableHeader>Telefone Comercial</TableHeader>}
                        {contribuintesVisibleColumns.includes(
                          "Telefone Recado"
                        ) && <TableHeader>Telefone Recado</TableHeader>}
                        {contribuintesVisibleColumns.includes("Celular") && (
                          <TableHeader>Celular</TableHeader>
                        )}
                        {(editOnly || detailsOnly) && (
                          <TableHeader>Ações</TableHeader>
                        )}
                      </TableRow>
                    </TableHead>
                    <tbody>
                      {filteredContribuintes.length > 0 ? (
                        filteredContribuintes.map((contribuinte) => (
                          <TableRow key={contribuinte.id}>
                            {contribuintesVisibleColumns.includes("Nome") && (
                              <TableData>{contribuinte.nome}</TableData>
                            )}
                            {contribuintesVisibleColumns.includes("CPF") && (
                              <TableData>
                                {formatCpf(contribuinte.cpfCin)}
                              </TableData>
                            )}
                            {contribuintesVisibleColumns.includes("Email") && (
                              <TableData>{contribuinte.email}</TableData>
                            )}
                            {contribuintesVisibleColumns.includes("Sexo") && (
                              <TableData>
                                {contribuinte.sexo === 1
                                  ? "Masculino"
                                  : "Feminino"}
                              </TableData>
                            )}
                            {contribuintesVisibleColumns.includes("RG") && (
                              <TableData>{contribuinte.rg}</TableData>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Data de Nascimento"
                            ) && (
                              <TableData>
                                {contribuinte.dataNascimento
                                  ? new Date(
                                      contribuinte.dataNascimento
                                    ).toLocaleDateString("pt-BR", {
                                      timeZone: "UTC",
                                    })
                                  : "Data não disponível"}
                              </TableData>
                            )}
                            {contribuintesVisibleColumns.includes("CEP") && (
                              <TableData>{contribuinte.cep}</TableData>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Endereço"
                            ) && (
                              <TableData>{`${contribuinte.endereco}, ${contribuinte.numeroResidencial}`}</TableData>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Complemento"
                            ) && (
                              <TableData>
                                {contribuinte.complementoEndereco}
                              </TableData>
                            )}
                            {contribuintesVisibleColumns.includes("Bairro") && (
                              <TableData>{contribuinte.bairro}</TableData>
                            )}
                            {contribuintesVisibleColumns.includes("Cidade") && (
                              <TableData>
                                {contribuinte.cidade === null
                                  ? ""
                                  : contribuinte.uf === null
                                  ? contribuinte.cidade
                                  : `${contribuinte.cidade} - ${contribuinte.uf}`}
                              </TableData>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Telefone Residencial"
                            ) && (
                              <TableData>
                                {contribuinte.telefoneResidencial}
                              </TableData>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Telefone Comercial"
                            ) && (
                              <TableData>
                                {contribuinte.telefoneComercial}
                              </TableData>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Telefone Recado"
                            ) && (
                              <TableData>
                                {contribuinte.telefoneRecado}
                              </TableData>
                            )}
                            {contribuintesVisibleColumns.includes(
                              "Celular"
                            ) && <TableData>{contribuinte.celular}</TableData>}
                            {(editOnly || detailsOnly) && (
                              <TableData
                                key={`actions-${contribuinte.id}`}
                                style={{
                                  position: "relative",
                                  overflow: "visible",
                                }}
                              >
                                <Button
                                  schemaButton="full-primary"
                                  action={() =>
                                    selectContribuinte(contribuinte)
                                  }
                                  icon={
                                    <IoIosDocument
                                      size={20}
                                      style={{ marginRight: "8px" }}
                                    />
                                  }
                                >
                                  Gerar declaração
                                </Button>
                              </TableData>
                            )}
                          </TableRow>
                        ))
                      ) : (
                        <tr>
                          <TableData
                            colSpan={contribuintesVisibleColumns.length + 1}
                            className="text-center"
                          >
                            {!filteredContribuintes.length
                              ? "Utilize o campo de busca para encontrar um contribuinte."
                              : "Nenhum contribuinte encontrado."}
                          </TableData>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                )}
              </div>
            </TableContainer>
          )}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </>
        {showModal && (
          <DeclaracaoModal
            contribuinte={selectedContribuinte!}
            onClose={() => setShowModal(false)}
            show={showModal}
          />
        )}
      </MainContainer>
    </>
  );
};

export default DeclaracaoAnualContribuicaoVoluntaria;
